import { useEffect, useState } from 'react';
import ProtocolService from '../../service/index';

/**
 * Hook customizado para buscar e ordenar usuários associados a um Tipo de Registro (Record Type).
 * * Por padrão, este hook filtra apenas usuários ATIVOS para garantir a integridade 
 * da seleção de responsáveis em fluxos de protocolo.
 *
 * @param {string|number} recordTypeId - O ID do tipo de registro para filtrar os usuários.
 * @param {Object} [options={}] - Configurações opcionais de busca.
 * @param {boolean|null} [options.active=true] - Define o filtro de status:
 * - `true`: Retorna apenas usuários ativos (Padrão).
 * - `false`: Retorna apenas usuários inativos.
 * - `null`: Retorna todos os usuários (sem filtro de status).
 * * @returns {{ users: Array<{ login: string, name: string }> }} Objeto contendo a lista de usuários ordenada por nome.
 * * @example
 * // Busca apenas ativos (padrão)
 * const { users } = useFetchUsersByRecordType(5);
 * * // Busca todos os usuários (ativos e inativos)
 * const { users } = useFetchUsersByRecordType(5, { active: null });
 */
export const useFetchUsersByRecordType = (recordTypeId, options = {}) => {
  const [users, setUsers] = useState([]);
  const { active = true } = options;

  useEffect(() => {
    async function fetchUsersByRecordType(recordTypeId) {
      try {
        const response = await ProtocolService.getUsersByRecordTypeId(
          recordTypeId,
          active
        );

        const users = (response?.data || []).sort((a, b) => {
          if (a?.name.toLowerCase() < b?.name.toLowerCase()) return -1;
          if (a?.name.toLowerCase() > b?.name.toLowerCase()) return 1;
          return 0;
        });

        setUsers(users);
      } catch (err) {
        console.log(err);
      }
    }

    fetchUsersByRecordType(recordTypeId);
  }, [recordTypeId, active]);

  return { users };
};
